import { useConnexionStore } from "../../stores/Layout/connexion";
import { verifyMailIfExist } from "../../services/Api/userService";
import { useCreateAccount } from "../../stores/Layout/createAccount";
import { useState } from "react";
import { showToastError } from "../../services/Toasts/toasts";

const VerifyEmailRegister = () => {
  // Store
  const { showModalVerifyEmail, setShowModalVerifyEmail } = useConnexionStore();
  const { email, setEmail } = useCreateAccount();
  const [info, setInfo] = useState<string>("");

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setInfo("");
    verifyMailIfExist(email)
      .then((data) => {
        if (data.exist === true && data.associated === false) {
          setInfo(
            "✅ Un email de création de compte vient de vous être envoyé."
          );
        } else if (data.exist === true && data.associated === true) {
          setInfo(
            "Un compte associé à ces informations existe déjà. Veuillez essayer de vous connecter."
          );
        } else if (data.exist === false && data.associated === false) {
          setInfo(
            "❌ Vous n'avez pas été invité à rejoindre Nexum. Pour tout renseignement supplémentaire, merci de contacter le service informatique de Trionode."
          );
        } else {
          setInfo("");
        }
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  if (!showModalVerifyEmail) return null;

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[85%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Création de compte
              </h4>
            </div>
            
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                  Vérification de votre adresse mail
                </h3>
                <p className="text-md text-gray-600 text-center mb-4">
                  Veuillez saisir votre adresse email pour vérifier votre invitation et créer votre compte.
                </p>
                
                {/* Info message */}
                {info && (
                  <div className="w-full mb-4 p-3 rounded-lg bg-gray-50 border border-gray-200">
                    <p className="text-sm text-gray-700 text-center leading-relaxed">
                      {info}
                    </p>
                  </div>
                )}
                
                {/* Email input */}
                <div className="w-full space-y-2">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700 block text-left w-full">
                    Adresse email
                  </label>
                  <input
                    type="email"
                    className="w-full h-12 px-4 rounded-xl bg-gray-50 border-2 border-gray-200 focus:border-yellow-trio focus:bg-white focus:outline-none transition-all duration-300 shadow-sm hover:shadow-md text-gray-700 placeholder-gray-400"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    onChange={(e) => setEmail(e.target.value)}
                    minLength={10}
                    maxLength={200}
                    name="email"
                    id="email"
                    placeholder="votre-email@exemple.com"
                    onKeyDown={handleKeyDown}
                    value={email}
                    required
                  />
                </div>
                
                <p className="text-sm text-gray-500 text-center mt-3 italic">
                  Nous vérifierons votre invitation et vous enverrons un email de confirmation.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => {
                  setShowModalVerifyEmail(false);
                  setInfo("");
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className="px-4 py-2 bg-yellow-trio hover:bg-yellow-400 cursor-pointer text-gray-700 font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                type="submit"
                onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                  handleSubmit(event);
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Vérifier
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-45 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default VerifyEmailRegister;
